import { create } from "zustand";
import { createJSONStorage, persist } from "zustand/middleware";

type JobCreateDraftState = {
  companyId: string | number | null;
  scopeOfWork: unknown;
  quote: unknown;
  selectedService: unknown;
  hasHydrated: boolean;
  setDraft: (payload: { companyId?: string | number | null; scopeOfWork?: unknown; quote?: unknown; selectedService?: unknown }) => void;
  clearDraft: () => void;
  setHasHydrated: (hasHydrated: boolean) => void;
};

export const useJobCreateDraftStore = create<JobCreateDraftState>()(
  persist(
    (set) => ({
      companyId: null,
      scopeOfWork: null,
      quote: null,
      selectedService: null,
      hasHydrated: false,
      setDraft: ({ companyId, scopeOfWork, quote, selectedService }) =>
        set({
          companyId: companyId ?? null,
          scopeOfWork: scopeOfWork ?? null,
          quote: quote ?? null,
          selectedService: selectedService ?? null,
        }),
      clearDraft: () => set({ companyId: null, scopeOfWork: null, quote: null, selectedService: null }),
      setHasHydrated: (hasHydrated) => set({ hasHydrated }),
    }),
    {
      name: "job-create-draft",
      storage: createJSONStorage(() => localStorage),
      partialize: ({ companyId, scopeOfWork, quote, selectedService }) => ({
        companyId,
        scopeOfWork,
        quote,
        selectedService,
      }),
      onRehydrateStorage: () => (state) => {
        state?.setHasHydrated(true);
      },
    },
  ),
);
